import delegate from 'delegate'

// Use child link on parent click

export default function () {
  delegate(
    '[data-sublink]',
    'click',
    (e) => {
      if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON') {
        return
      }

      const a = e.delegateTarget.querySelector('a')
      if (a && e.target !== a) {
        if (e.metaKey) {
          // Open in a new tab if Cmd or Windows key is pressed
          const newTab = window.open(a.href, '_blank');
          newTab.focus();
        } else {
          a.click()
        }
        return
      }
      const btn = e.delegateTarget.querySelector('button')
      if (btn && e.target !== btn) {
        btn.click()
        return
      }
    },
    false
  )
}